import { z } from 'zod';
import i18n from '@/i18n';

export const registrationStepFourthSchema = z.object({
    min_age: z.number(),
    max_age: z.number(),
    purpose: z.enum(['love', 'fun', 'not_specified']).nullable(),
    // @ts-ignore
    looks_for: z.enum(['male', 'female', 'any'], { message: i18n.t('gender_required') }),
});

export type RegistrationStepFourthType = z.infer<typeof registrationStepFourthSchema>;
